{
  "noAssignedModeling": "",
  "modelings": "",
  "pleaseSignIn": "",
  "email": "",
  "enterLogin": "",
  "signIn": "",
  "password": "",
  "enterPassword": "",
  "filterByName": "",
  "settings": "",
  "logout": "",
  "home": "",
  "users": "",
  "areas": "",
  "modelingName": "",
  "passwordChange": "",
  "close": "",
  "confirm": "",
  "userDelete": "",
  "wannaDeleteThisUser": "",
  "delete": "",
  "userCreation": "",
  "create": "",
  "name": "",
  "enterUserName": "",
  "loginName": "",
  "role": "",
  "chooseRole": "",
  "projectadmin": "",
  "viewer": "",
  "admin": "",
  "team": "",
  "teamName": "",
  "group": "",
  "groups": "",
  "chooseGroup": "",
  "choose": "",
  "groupCreation": "",
  "enterGroupName": "",
  "groupDetail": "",
  "save": "",
  "userDetail": "",
  "string": "",
  "integer": "",
  "decimal": "",
  "dateTime": "",
  "boolean": "",
  "column": "",
  "dataType": "",
  "row": "",
  "tableName": "",
  "import": "",
  "dataSpaces": "",
  "noAssignedDataSpace": "",
  "dataspaces": "",
  "dataSpaceName": "",
  "dataSpaceCreation": "",
  "dataSpaceDetail": "",
  "wannaDeleteThisDataSpace": "",
  "dataSpaceDelete": "",
  "allDataWillBeLost": "",
  "tables": "",
  "batches": "",
  "tablesInDataSpace": "",
  "batchesInDataSpace": "",
  "searchTable": "",
  "noTables": "",
  "tableDetail": "",
  "structure": "",
  "dataPreview": "",
  "noData": "",
  "confirmDeleteTable": "",
  "importCsv": "",
  "file": "",
  "delimiter": "",
  "semicolon": "",
  "comma": "",
  "tab": "",
  "columns": "",
  "importing": "",
  "newBatch": "",
  "editBatch": "",
  "noBatches": "",
  "confirmDeleteBatch": "",
  "batchName": "",
  "batchNamePlaceholder": "",
  "createBatch": "",
  "batchType": "",
  "dataLoadMethod": "",
  "typeCopy": "",
  "typeCopyDesc": "",
  "typeAggregation": "",
  "typeAggregationDesc": "",
  "typeCsd": "",
  "typeCsdDesc": "",
  "output": "",
  "input": "",
  "inputs": "",
  "transformation": "",
  "copy": "",
  "aggregation": "",
  "inputTable": "",
  "outputTable": "",
  "outputTableName": "",
  "selectTable": "",
  "outputIdName": "",
  "outputFromName": "",
  "outputToName": "",
  "inputIdName": "",
  "inputFromName": "",
  "inputToName": "",
  "includeColumns": "",
  "addColumn": "",
  "alias": "",
  "function": "",
  "selectFunction": "",
  "groupBy": "",
  "aggregateColumns": "",
  "transformationSteps": "",
  "stepTable": "",
  "stepColumns": "",
  "addStep": "",
  "addInput": "",
  "addTable": "",
  "expressions": "",
  "expression": "",
  "addExpression": "",
  "expressionPlaceholder": "",
  "moveUp": "",
  "moveDown": "",
  "run": "",
  "runDataBatch": "",
  "areYouSureYouWantToRunThisDataBatch": "",
  "running": "",
  "batchRunSuccessful": "",
  "batchRunUnsuccessful": "",
  "tableAlreadyExists": "",
  "unknownError": "",
  "type": "",
  "status": "",
  "origin": "",
  "source": "",
  "rows": "",
  "size": "",
  "created": "",
  "cancel": "",
  "edit": "",
  "back": "",
  "continue": "",
  "loading": "",
  "lastRun": "",
  "duration": "",
  "saveAndRun": "",
  "addGroupBy": "",
  "transformations": "",
  "transformationTable": "",
  "addTransformation": "",
  "creationType": "",
  "createdBy": "",
  "createdDate": "",
  "export": "",
  "detail": "",
  "recreateTable": "",
  "copyBatch": "",
  "newBatchName": "",
  "copying": "",
  "batchCopySuccessful": "",
  "deleteBatch": "",
  "deleting": "",
  "batchDeleteSuccessful": ""
}